var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenu9 = function SvgIconMenu9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-menu-9_svg__b",
    width: 49,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-menu-9_svg__a)",
    d: "M35.187 10.688H13.812c-.708 0-1.333.27-1.875.812-.5.5-.75 1.104-.75 1.813v24L16.5 32h18.687A2.47 2.47 0 0 0 37 31.25c.542-.542.812-1.188.812-1.938v-16c0-.708-.27-1.312-.812-1.812-.5-.542-1.104-.813-1.813-.813Zm-8.625 12.75L24.5 28l-2.063-4.563-4.625-2.125 4.625-2.062 2.063-4.563 2.062 4.563 4.625 2.063-4.625 2.125Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-menu-9_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-menu-9_svg__c)",
    d: "M.5 0h48v48H.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-menu-9_svg__a",
    x1: 40.5,
    x2: 40.5,
    y1: 40,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8214A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-menu-9_svg__c",
    x1: 72.511,
    x2: 24.5,
    y1: 24,
    y2: -24.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })))));
};
export default SvgIconMenu9;